export default __webpack_public_path__ + "static/media/barbedWire.5269a6bf.png";